"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = void 0;
let _config = {
    onUnhandledError() {
        /*do nothing */
    }
};
function setHoustonHooksConfig(config) {
    _config = config;
    Promise.resolve().then(() => __importStar(require('rxjs'))).then(rxjs => {
        if (rxjs.config && !rxjs.config.onUnhandledError) {
            rxjs.config.onUnhandledError = err => config.onUnhandledError(err, 'rxjs');
        }
    })
        .catch(() => {
        /* Sem problemas, o projeto não tem rxjs */
    });
}
exports.default = setHoustonHooksConfig;
function getConfig() {
    return _config;
}
exports.getConfig = getConfig;
